import { GetterTree } from "vuex";
import { RootState } from "../types";
import { DraftsInterface } from "./types";
export const getters: GetterTree<DraftsInterface, RootState> = {};
